<script setup>
import BaseHeader from "@/components/base/base-header.vue";
import BaseFooter from "@/components/base/base-footer.vue";
import {computed, onMounted, watch} from "vue";
import {Categories} from "@/core/api/categories.js";
import {useI18n} from "vue-i18n";
import {useCategoryStore} from "@/stores/category.js";
import {Orders} from "@/core/api/orders.js";
import {Wishlist} from "@/core/api/wishlist.js";
import {Processes} from "@/core/api/processes.js";
import {Auth} from "@/core/api/auth.js";
import {useCompanyStore} from "@/stores/company.js";
import {useAuthStore} from "@/stores/auth.js";
import {useCartStore} from "@/stores/cart.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import Contact from "@/components/contact.vue";
import {useAppStore} from "@/stores/app.js";
import {useRoute} from "vue-router";

const {locale} = useI18n()
const categoryStore = useCategoryStore()
const authStore = useAuthStore()
const cartStore = useCartStore()
const companyStore = useCompanyStore()
const wishlistStore = useWishlistStore()
const appStore = useAppStore()
const route = useRoute()

const checkUserAuth = async () => {
  const [res, companyRes] = await Promise.all([Auth.refresh(), Processes.getCompanyInfo()]);

  if (companyRes) {
    companyStore.setCompanyInfo(companyRes.data.parameters)
  }

  if (res.data) {
    authStore.setUser({
      user: res.data.refreshJwtToken.user,
      accessToken: res.data.refreshJwtToken.accessToken
    })

    localStorage.setItem('nest-refresh', res.data.refreshJwtToken.refreshToken)

    const currentOrder = await Orders.getOrders("PENDING", res.data.refreshJwtToken.accessToken, res.data.refreshJwtToken.user.email)
    cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)

    const wishlistRes = await Wishlist.getWishlist(res.data.refreshJwtToken.accessToken)
    wishlistStore.wishlist = wishlistRes.data.wishlists.edges[0].node
  }
}

const getCategories = async () => {
  const res = await Categories.getCategories()
  categoryStore.setCategories(res.data.categories.edges)
}

const activeViewProduct = computed(() => {
  return appStore.activeViewProduct
})

const lockScroll = () => {
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
};

const unlockScroll = () => {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.width = '';
};

watch(activeViewProduct, (isOpen) => {
  if (isOpen) {
    lockScroll();
  } else {
    unlockScroll();
  }
});

watch(locale, async () => {
  await getCategories()
})

onMounted(async () => {
  await getCategories()
  await checkUserAuth()

  setInterval(async () => {
    await checkUserAuth()
  }, 600000)
})
</script>

<template>
  <div class="main" id="top">
<!--    <div class="main__buttons">-->
<!--      <a href="https://t.me/ecommasterweb" target="_blank">-->
<!--        <img src="@images/bottomTg.png" alt="">-->
<!--      </a>-->
<!--      <a href="https://ecommasterweb.com" target="_blank">-->
<!--        <img src="@images/bottomEcom.png" alt="">-->
<!--      </a>-->
<!--    </div>-->
    <base-header v-if="route.name !== 'checkout'" />
    <RouterView v-slot="{ Component }" class="page">
      <Transition name="opacity" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <contact v-if="route.name !== 'checkout'" />
    <base-footer v-if="route.name !== 'checkout'" />
  </div>
</template>

<style lang="scss">
.main {
  position: relative;

  &__buttons {
    position: fixed;
    right: 20px;
    bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 1000;

    & a {
      border-radius: 17px !important;
      box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.15);
      height: 33px;
      width: 33px;
      display: grid;
      place-items: center;
      position: relative;

      & img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 43px;
      }

      &:last-child {
        width: 76px;

        & img {
          width: 86px;
        }
      }
    }
  }
}

.swiper-pagination {
  bottom: 0 !important;
  width: fit-content !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  border-radius: 6px !important;
  opacity: 0.9 !important;
  background-color: transparent !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 5px 10px !important;
}
.swiper-pagination-bullet {
  transition: 0.2s !important;
  border-radius: 8px;
  background-color: #D9D9D9 !important;
  opacity: 1 !important;
  width: 8px !important;
  height: 8px !important;
}
.swiper-pagination-bullet-active {
  background-color: #008ECC !important;
  width: 24px !important;
  height: 8px !important;
  border-radius: 36px !important;
}
</style>